import gql from 'graphql-tag';

export const FeaturedContentQuery = gql`
  {
    Articles(filter: {featured: true}) {
      _id
      title
      date
      image
      featuredOrderPriority
    }
    Releases(filter: {featured: true}) {
      _id
      title
      date
      hasUnknownDay
      imageUrls
      featuredOrderPriority
    }
  }
`;

export const UpdateReleaseOrderPriorityMutation = gql`
  mutation($id: String!, $priority: Int!) {
    updateRelease(filter: {_id: $id}, update: {featuredOrderPriority: $priority}) {
      _id
      featuredOrderPriority
    }
  }
`;

export const UpdateArticleOrderPriorityMutation = gql`
  mutation($id: String!, $priority: Int!) {
    updateArticle(filter: {_id: $id}, update: {featuredOrderPriority: $priority}) {
      _id
      featuredOrderPriority
    }
  }
`;
